import type { Resource } from '../../';
export const product_details_outOfStock: Resource = {"default":"Out of Stock"};
